import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    baseUrl = environment.baseUrl;

    constructor(private httpService: HttpClient) { }

    login(data: any) {
        return this.httpService.post(`${this.baseUrl}auth/loginUser`, data);
    }

    logout() {
        return this.httpService.post(`${this.baseUrl}logout`,{});
    }


}
